import request from "@/utils/request";


export function authStatusF(param) {
  return request({
    url: 'api/users/auth/queryResult?outer_order_no='+param,
    method: 'get'
  })
}

export function authInfo() {
  return request({
    url: 'api/users/auth/info',
    method: 'get'
  })
}

export function companyverify(param) {
  return request({
    url: 'api/users/auth/companyverify',
    method: 'post',
	data:param
  })
}

export function businesssave(param) {
  return request({
    url: 'api/users/auth/businesssave',
    method: 'post',
	data:param
  })
}

export function backfillcode(param) {
  return request({
    url: 'api/users/auth/backfillcode',
    method: 'post',
	data:param
  })
}

export function personsave(param) {
  return request({
    url: 'api/users/auth/personsave',
    method: 'post',
	data:param
  })
}


export function mobileStatus() {
  return request({
    url: 'api/users/auth/status?cate=1',
    method: 'get'
  })
}

export function mobileverify() {
  return request({
    url: 'api/users/auth/mobileverify',
    method: 'get'
  })
}

export function perFaceTencent() {
  return request({
    url: 'api/users/auth/tencentface',
    method: 'get'
  })
}

export function perAuthAlipay() {
  return request({
    url: 'api/users/auth/alipayauth',
    method: 'get'
  })
}

export function perFaceAlipay() {
  return request({
    url: 'api/users/auth/alipayface',
    method: 'get'
  })
}

export function getocrinfo(param) {
  return request({
    url: 'api/users/auth/getocrinfo',
    method: 'post',
	data:param
  })
}

